"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Highlight = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var highlight_words_core_1 = require("highlight-words-core");
var STRIKE_CLASS = "text-sorbus-default bg-danger bg-opacity-25 line-through";
var HIGHLIGHT_CLASS = "text-sorbus-default border-sorbus-default bg-opacity-25 font-bold";
var REPLACE_CLASS = "text-lochivar-default bg-lochivar bg-opacity-25 font-bold";
var Highlight = function (_a) {
    var textToHighlight = _a.content, searchWords = _a.match, replace = _a.replace, caseSensitive = _a.caseSensitive, _b = _a.replaceClass, replaceClass = _b === void 0 ? REPLACE_CLASS : _b, _c = _a.strikeClass, strikeClass = _c === void 0 ? STRIKE_CLASS : _c, _d = _a.highlightClass, highlightClass = _d === void 0 ? HIGHLIGHT_CLASS : _d;
    var chunks = (0, highlight_words_core_1.findAll)({
        searchWords: searchWords,
        textToHighlight: textToHighlight,
        caseSensitive: caseSensitive,
    });
    var highlightedText = chunks.map(function (chunk) {
        var end = chunk.end, highlight = chunk.highlight, start = chunk.start;
        var text = textToHighlight.substr(start, end - start);
        var key = [text, end, highlight, start].join("-");
        if (highlight) {
            return ((0, jsx_runtime_1.jsxs)(react_1.default.Fragment, { children: [(0, jsx_runtime_1.jsx)("mark", __assign({ className: replace ? strikeClass : highlightClass }, { children: text }), void 0), replace ? (0, jsx_runtime_1.jsx)("mark", __assign({ className: replaceClass }, { children: replace }), void 0) : null] }, key));
        }
        else {
            return (0, jsx_runtime_1.jsx)("span", { children: text }, key);
        }
    });
    return (0, jsx_runtime_1.jsx)("p", { children: highlightedText }, void 0);
};
exports.Highlight = Highlight;
